<template>
<Fragment :key="checkoutKey">
    <template >
        <ProgressiveDiscountNotice :notice="progressiveDiscountNotice" />
        <CartTableProducts
            page="checkout"
            :products_settings="products_settings"
        >
            <template #footer="slotProps">
                <tr>
                    <td style="text-align:left;" :colspan="slotProps.summaryColspan">
                        <c-form-group
                            v-if="company && company.observation_on_purchase"
                            class="form-group"
                            style="width: 100%;"
                        >
                            <label for="observacao_pedido">
                                <strong>
                                    Informações complementares
                                </strong>
                            </label>
                            <textarea
                                name="observacao_pedido"
                                id="observacao_pedido"
                                required="required"
                                class="form-control"
                                style="height: 70px;"
                                v-model="observacao"
                                :placeholder="`Escreva aqui suas observações sobre o ${isBudgetLayout ? 'orçamento' : 'pedido'}`"
                            >
                            </textarea>
                        </c-form-group>
                    </td>
                    <td style="text-align: right;" class="total-checkout">
                        <template>
                            <span v-if="hasDiscounts || showDeliveryMethods">
                                <strong>Subtotal:</strong>
                                {{currency.money(itemsCart.subTotal)}}
                            </span>
                            <span v-if="hasDiscounts">
                                <button
                                    type="button"
                                    style="border: 0; background: transparent; padding: 0; font: inherit; cursor: pointer; font-weight: 700;"
                                    @click.prevent="toggleDiscounts"
                                >
                                    Descontos:
                                    <i :class="['fas', discountsExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                                </button>
                                {{currency.money(totalDiscountAmount)}}
                            </span>
                            <template v-if="hasDiscounts && discountsExpanded">
                                <span
                                    v-for="discount in discountBreakdown"
                                    :key="discount.label"
                                    style="font-size: 13px;"
                                >
                                    {{ discount.label }}: -{{ currency.money(discount.amount) }}
                                </span>
                            </template>
                        </template>
                        <template v-if="showDeliveryMethods">
                            <!-- <strong v-if="getShippingPrice() || !shippingMethod" style="font-size:18px">Frete:</strong>
                            <span v-if="shippingMethod" style="font-size:16px">
                                {{getShippingPrice()}}
                            </span>
                            <small v-if="!shippingMethod">
                                (defina abaixo)
                            </small>
                            <br v-if="getShippingPrice() || !shippingMethod"> -->

                            <span>
                                <strong>Frete:</strong>
                                <template v-if="getShippingPrice()">
                                    {{getShippingPrice()}}
                                </template>
                                <small v-else>
                                    (defina abaixo)
                                </small>
                            </span>
                        </template>
                        <span>
                            <strong>Total:</strong>
                            {{ currency.money(itemsCart.totalAmount) }}
                            <template v-if="show_ipi && !calculateIpi">
                                + IPI
                            </template>
                        </span>
                    </td>
                </tr>
            </template>
        </CartTableProducts>
    </template>
</Fragment>
</template>

<script>
import VueLoadImage from 'vue-load-image'
import { Fragment } from 'vue-fragment'
import Currency from '../../helpers/parseCurrency'
import {mapState, mapActions, mapGetters} from 'vuex'
import { CCartTableContainer } from '../Styles/Template/styled'
import { CFormGroup } from '../Styles/Components/styled'
import CartTableProducts from '../CartTableProducts.vue'
import ProgressiveDiscountNotice from '../cart/ProgressiveDiscountNotice.vue'
import { buildCartTrackingItems } from '../../helpers/tracking'

export default {
    name: 'ProductsCheckout',
    components: {
        Fragment,
        CartTableProducts,
        'vue-load-image': VueLoadImage,
        'c-form-group': CFormGroup,
        'cart-table-container': CCartTableContainer,
        ProgressiveDiscountNotice
    },
    props: {
        products_settings: {required: true}
    },
    data() {
        return {
            currency: Currency,
            settings: this.$root.$children[0].$attrs.company?.settings ?? null,
            textTransform: this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? '',
            discountsExpanded: false
        }
    },
    async created() {
        await this.getItemsCart()
        this.ActionGetShippingMethod()
    },
    methods: {
        ...mapActions("shipping", [
            "ActionSetShippingMethodState",
            "ActionGetShippingMethod"
        ]),
        ...mapActions("cart", [
            "ActionSetItemsCart",
            "ActionGetItemsCart"
        ]),
        ...mapActions("payment", [
            "ActionSetObservacao"
        ]),
        async getItemsCart() {
            try {
                const response = await this.ActionGetItemsCart()
                this.ActionSetItemsCart(response.data)
                this.trackBeginCheckout(response.data)
            } catch(error) {
                console.log('ERROR GET ITEMS CART: '+error?.msg ?? error)
            }
        },
        trackBeginCheckout(cart) {
            try {
                if (typeof gtag !== 'function' || !cart?.list?.length) {
                    return
                }

                gtag('event', 'begin_checkout', {
                    pageTitle: this.company?.nome_fantasia ?? '',
                    pageCategory: 'Finalização de Pedido',
                    ecommerce: {
                        currency: 'BRL',
                        value: Number(cart.totalAmount ?? cart.subTotal ?? 0),
                        items: buildCartTrackingItems(cart.list)
                    }
                })
            } catch (error) {
                console.warn('Erro ao disparar begin_checkout', error)
            }
        },
        calculateSubTotal(item) {
            let price = !item.price_to ? item.pro_price_site : item.price_to
            return parseFloat(price) * item.qtd_cart
        },
        getShippingPrice() {
            if(this.shippingMethod?.ShippingPrice) {
                return this.currency.money(this.shippingMethod.ShippingPrice)
            }
            if(this.shippingMethod?.price) {
                return this.currency.money(this.shippingMethod.price)
            }
            return null;
        },
        toggleDiscounts() {
            this.discountsExpanded = !this.discountsExpanded
        }
    },
    watch: {
        itemsCart(data) {
            if (!data?.list?.length) {
                window.location.href = this.$baseUrl
                return
            }
            if(!data) {
                return
            }
            this.ActionSetShippingMethodState(data.shippingMethod)
            data.list.forEach(element => {
                element.pro_name_site = this.textTransform == 'uppercase' ? element.pro_name_site.toUpperCase() :
                    this.textTransform == 'lowercase' ? element.pro_name_site.toLowerCase() :
                    this.textTransform == 'initial' ? (element.pro_name_site[0].toUpperCase() + element.pro_name_site.substr(1).toLowerCase()) :
                    this.textTransform == 'capitalize' ? (element.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })): element.pro_name_site
            });
        }
    },
    computed: {
        ...mapState("cart", [
            "itemsCart",
            "checkoutKey"
        ]),
        ...mapState("shipping", [
            "shippingMethod"
        ]),
        ...mapState("company", [
            "company"
        ]),
        ...mapGetters("company", [
            "showDeliveryMethods",
            "showIpi",
            "showDiscountCoupon"
        ]),
        ...mapState("payment", {
            observacaoFromStore: 'observacao'
        }),
        observacao: {
            get() {
                return this.observacaoFromStore
            },
            set(value) {
                this.ActionSetObservacao(value)
            }
        },
        show_ipi() {
            return (this.showIpi && this?.itemsCart?.list?.some(el => el?.ipi_percentage))
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        calculateIpi() {
            return this.$root.$children[0].$attrs.company?.settings?.calculate_ipi ?? false
        },
        discountBreakdown() {
            const discounts = [...(this.itemsCart?.discountBreakdown ?? [])]
            if (this.hasShippingDiscount) {
                discounts.push({
                    label: 'Frete',
                    amount: this.itemsCart.shippingDiscountAmount
                })
            }
            return discounts
        },
        totalDiscountAmount() {
            return Number(this.itemsCart?.discountAmount ?? 0) + Number(this.itemsCart?.shippingDiscountAmount ?? 0)
        },
        hasDiscounts() {
            return this.totalDiscountAmount > 0
        },
        hasShippingDiscount() {
            return Number(this.itemsCart?.shippingDiscountAmount ?? 0) > 0
        },
        progressiveDiscountNotice() {
            return this.itemsCart?.progressiveDiscountNotice ?? null
        }
    }
}
</script>
